import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox, Chip, TextField } from '@mui/material';
import type React from 'react';
import { useEffect, useState } from 'react';

interface IProps {
  id: string;
  items: Array<any>;
  itemKey: string;
  itemText: string;
  itemTagText?: string;
  labelText: string;
  multiSelect: boolean;
  placeHolderText: string;
  controlWidth?: number;
  labelPaddingTop?: string;
  defaultValue?: any;
  onBlur?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onChange: (value: any) => void;
  isRequired?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  allowEmptyValue?: boolean;
  groupBy?: string;
  allowSelectAllOption?: boolean;
  limitTags?: number;
}
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const FuelAutoComplete = ({
  id,
  items,
  itemKey,
  itemText,
  itemTagText,
  labelText,
  multiSelect,
  placeHolderText,
  controlWidth,
  labelPaddingTop,
  defaultValue,
  onChange,
  onBlur,
  isRequired = false,
  hasError = false,
  disabled = false,
  allowEmptyValue = false,
  groupBy = null,
  allowSelectAllOption = false,
  limitTags = 1,
}: IProps) => {
  // Set defaults
  if (placeHolderText == null) placeHolderText = 'Select option';
  if (!itemKey) itemKey = 'id';
  if (!itemTagText) itemTagText = itemText;
  if (!items) items = [];

  if (!defaultValue) {
    if (multiSelect) {
      defaultValue = [];
    } else {
      defaultValue = '';
    }
  }

  // console.log('FuelSelect', { defaultValue, items, multiSelect });

  //   const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [selectedValues, setSelectedValues] = useState(defaultValue);

  const allSelected = selectedValues.length === items.length;
  const isPartialSelect = selectedValues.length > 0 && selectedValues.length < items.length;

  const handleChange = (event, values) => {
    if (multiSelect) {
      const selectAllOption = values.find((option) => option[id] === 'selectAll');
      if (selectAllOption) {
        handleSelectAllToggle();
      } else {
        setSelectedValues(values);
        onChange(values);
      }
    } else {
      setSelectedValue(values);
      onChange(values);
    }
  };

  const handleSelectAllToggle = () => {
    if (allSelected) {
      setSelectedValues([]);
      onChange([]);
    } else {
      setSelectedValues(items);
      onChange(items);
    }
  };

  const removeOption = (id) => { };

  const getOptionLabel = (option) => {
    if (option && option[itemText]) {
      return option[itemText].toString();
    }
    return '';
  };

  useEffect(() => {
    setSelectedValue(defaultValue);
    setSelectedValues(defaultValue);
  }, [defaultValue]);

  return (
    <Autocomplete
      className="fuel-autocomplete"
      multiple={multiSelect}
      options={allowSelectAllOption && multiSelect ? [{ [itemText]: 'Select All', [id]: 'selectAll' }, ...items] : items}
      id={id}
      disableCloseOnSelect={multiSelect || false}
      getOptionLabel={getOptionLabel}
      value={multiSelect ? selectedValues : selectedValue}
      limitTags={limitTags}
      disabled={disabled}
      disableClearable={!allowEmptyValue}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            title={option[itemText]}
            variant="outlined"
            label={option[itemTagText]}
            size="small"
            {...getTagProps({ index })}
            key={index}
          />
        ))
      }
      // renderTags={(tagValue, getTagProps) =>
      //   tagValue.map((option, index) => (
      //     <Chip id={`option-${index}-${tagValue}`} title={option.title} label={option.title} {...getTagProps({ index })} />
      //   ))
      // }
      // getOptionSelected={(option, value) => option.id === value.id}
      renderOption={(props, option, { selected }) => {
        if (multiSelect) {
          const isSelectAll = option[id] === 'selectAll';
          return (
            <li {...props} key={option[itemKey]}>
              <Checkbox
                size="small"
                color="success"
                style={{
                  transform: 'scale(.6)',
                  marginRight: 8,
                }}
                checked={isSelectAll ? allSelected : selected}
              />
              {option[itemText]}
            </li>
          );
        }
        return (
          <li {...props} key={option[itemKey]}>
            {option[itemText]}
          </li>
        );
      }}
      onChange={handleChange}
      onBlur={(e) => onBlur && onBlur(e)}
      groupBy={groupBy}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={labelText}
          placeholder={placeHolderText}
          required={isRequired}
          error={hasError}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off',
          }}
        />
      )}
      isOptionEqualToValue={(option, value) => value === undefined || value === '' || option[itemKey] === value[itemKey]}
    />
  );
};

export default FuelAutoComplete;
